import { createApi } from "./client";
import type { CompanyInfo } from "../types/models";

export function getCompanyInfo(
    apiBase: string,
    companySlug: string
): Promise<CompanyInfo> {
    const api = createApi(apiBase);

    return api<CompanyInfo>(`/api/companies/${companySlug}`);
}
